import { WorkOrderBadge } from '../workOrder/badge';

export const UsInBondBadge = {
  ...WorkOrderBadge,
};

export const usInBondBadgeDescription = 'The US InBond badge. Example: Hot';

export type UsInBondBadge = keyof typeof UsInBondBadge;
